export default "__VITE_ASSET__8qrPs9rw__"